import { useEffect, useState } from "react";

const NOW_REFRESH_MS = 60_000;

export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), NOW_REFRESH_MS);
    return () => window.clearInterval(timer);
  }, []);
  return now;
}

/** The browser's own online flag is unreliable (false in sandboxes that only have loopback), so only a sync result decides what the indicator says; coming back online just triggers a sync. */
export function useSyncWhenBrowserReconnects(syncNow: () => void): void {
  useEffect(() => {
    window.addEventListener("online", syncNow);
    return () => window.removeEventListener("online", syncNow);
  }, [syncNow]);
}
